import { FunctionComponent, useEffect, useState } from 'react';
import { getCurrentTime } from '~/utils/dateTime';
import { ClockStyled } from './styled';

const Clock: FunctionComponent = () => {
  const [currentTime, setCurrentTime] = useState(getCurrentTime());

  useEffect(() => {
    let timer: number = 0;

    const updateTime = () => {
      timer = window.setInterval(() => {
        setCurrentTime(getCurrentTime());
      }, 1000);
    };

    updateTime();

    return () => clearInterval(timer!);
  }, []);

  return (
    <ClockStyled>
      <span>{currentTime}</span>
    </ClockStyled>
  );
};

export default Clock;
